import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import styles from './DropdownMenu-hashed.scss';

// FIX: turn into jsdoc example for component
// renderTrigger = (props, toggleMenu) => {
//     const {isOpen, className} = props;
//     const handleButtonClick = () => {
//         toggleMenu(!isOpen);
//     };
//     const classes = cx(
//         styles.userIcon,
//         className
//     );
//     return <button type="button" className={classes} onClick={handleButtonClick}>KB</button>;
// }
// <DropdownMenuLink>Item 1</DropdownMenuLink>
// <DropdownMenuLink>Item 2</DropdownMenuLink>
// <DropdownMenuLink>Item 3</DropdownMenuLink>
// <DropdownMenuLink checked>Checked</DropdownMenuLink>
// <DropdownMenuLink disabled>Disabled</DropdownMenuLink>
// <DropdownMenuSeparator />
// <DropdownMenuHeader>Heading</DropdownMenuHeader>
// <DropdownMenuLink>More...</DropdownMenuLink>

class DropdownMenu extends React.Component {
    static propTypes = {
        renderTrigger: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
        dropUp: PropTypes.bool,
        alignRight: PropTypes.bool,
        showCaret: PropTypes.bool, // caret on trigger button/icon/link
        showArrow: PropTypes.bool // notch in dropdownMenu menu
    };

    // FIX: add styles for arrow (to make tooltip like)
    // do we need offset to control the distance between the trigger and the menu?
    // or just make that a css variable?

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {isOpen: props.isOpen};
        this.myRef = React.createRef();
    }

    componentDidMount() {
        if (this.state.isOpen) {
            this.setClickListener();
        }
    }

    componentWillUnmount() {
        this.unsetClickListener();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen !== prevProps.isOpen) {
            this.toggleMenu(this.props.isOpen);
        }

        if (this.state.isOpen !== prevState.isOpen) {
            if (this.state.isOpen) {
                this.setClickListener();
            } else {
                this.unsetClickListener();
            }
        }
    }

    setClickListener = () => {
        window.addEventListener('click', this.hideMenu, false);
    }

    unsetClickListener = () => {
        window.removeEventListener('click', this.hideMenu);
    }

    hideMenu = (evt) => {
        // do not hide if not open
        if (!this.state.isOpen) {
            return;
        }

        // do not hide if clicking the trigger, but the menu
        const menu = this.myRef.current;
        const self = ReactDOM.findDOMNode(this);
        if (self.contains(evt.target) && !menu.contains(evt.target)) {
            return;
        }

        this.toggleMenu(false);
    }

    toggleMenu = (showOrHide) => {
        const newIsOpen = (showOrHide === undefined) ? !this.state.isOpen : showOrHide;
        if (this.state.isOpen !== newIsOpen) {
            this.setState({isOpen: newIsOpen});
        }
    }

    render() {
        const {
            dropUp, alignRight, showCaret, className, menuClassName, renderTrigger, children
        } = this.props;
        const {isOpen} = this.state;

        const componentClasses = cx(
            styles.dropdownMenu,
            {[styles['dropdownMenu-top']]: dropUp},
            {[styles['dropdownMenu-left']]: alignRight},
            {[styles.active]: isOpen},
            className
        );
        const triggerClasses = (showCaret) ? styles.dropdownTrigger : undefined;
        const menuClasses = cx(styles.menu, menuClassName);
        const dropdownTrigger = renderTrigger(
            {
                isOpen: isOpen,
                className: triggerClasses
            },
            this.toggleMenu
        );

        return (
            <div className={componentClasses}>
                {dropdownTrigger}
                <div className={menuClasses} ref={this.myRef}>
                    {children}
                </div>
            </div>
        );
    }
}

export default DropdownMenu;
